export const GBHE_TRIAL_ID = 34;
export const SIGN_UP_TRIAL_ID = 116;
export const GB_TUTOR_PILOT = 191;
export const GB_TUTOR_PILOT_BASIC = 192;
export const JC_SUBSCRIPTION_PLAN = {
  ONLINE_ANNUAL: '227',
  ONLINE_6MOS: '229',
  ONLINE_3MOS: '230',
  ONLINE_2YEARS: '231',
  ONLINE_3YEARS: '232',
  ONLINE_2ND_YEAR_ADDON: '233',
  ONLINE_3RD_YEAR_ADDON: '234',
  HYBRID_CAMPUS: '218', // is a `CUSTOM_GENIEBOOK_CAMPUS_PLAN_ID`
} as const;
